import { TmBaseComponent } from '@treasury/presentation';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export const tagName = 'header-text';
@customElement(tagName)
export class HeaderText extends TmBaseComponent {
    @property()
    public header?: string;

    @property()
    public subheader?: string;

    public render() {
        const header = html`<div class="text-base font-normal leading-none">${this.header}</div>`;
        const subheader = this.subheader
            ? html`<div
                  class="font-light text-xs leading-none absolute mx-auto inset-x-0 text-center"
              >
                  ${this.subheader}
              </div>`
            : nothing;

        return html`<div class="relative">${header}${subheader}</div> `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: HeaderText;
    }
}
